import styled from "styled-components";

const StyledTitle = styled.h1`
  font-size: 20px;
  font-weight: 600;
  text-align: left;
  margin-bottom: 10px;
`;

const Title = ({ title }: { title: string }) => {
  return <StyledTitle>{title}</StyledTitle>;
};

export default Title;
